<template>
  <div class="stage-manager">
    <img src="~@/assets/img/stage-manager-1.png" alt="Manager animation Frame 1" />
    <img src="~@/assets/img/stage-manager-2.png" alt="Manager animation Frame 2"/>
    <img src="~@/assets/img/stage-manager-3.png" alt="Manager animation Frame 3"/>
    <img src="~@/assets/img/stage-manager-4.png" alt="Manager animation Frame 4"/>
    <img src="~@/assets/img/stage-manager-5.png" alt="Manager animation Frame 5"/>
    <img src="~@/assets/img/stage-manager-6.png" alt="Manager animation Frame 6"/>
    <img src="~@/assets/img/stage-manager-7.png" alt="Manager animation Frame 7"/>
    <img src="~@/assets/img/stage-manager-8.png" alt="Manager animation Frame 8"/>
    <img src="~@/assets/img/stage-manager-10.png" alt="Manager animation Frame 9"/>
    <img src="~@/assets/img/stage-manager-11.png" alt="Manager animation Frame 10"/>
    <img src="~@/assets/img/stage-manager-12.png" alt="Manager animation Frame 11"/>
    <img src="~@/assets/img/stage-manager-13.png" alt="Manager animation Frame 12"/>
    <img src="~@/assets/img/stage-manager-14.png" alt="Manager animation Frame 13"/>
    <img src="~@/assets/img/stage-manager-15.png" alt="Manager animation Frame 14"/>
    <img src="~@/assets/img/stage-manager-16.png" alt="Manager animation Frame 15"/>
  </div>
</template>

<script>
export default {
  name: "Manager"
};
</script>

<style lang="scss">
@keyframes walk {
  0%,
  6.25% {
    background-image: url("~@/assets/img/stage-manager-1.png");
  }
  6.25%,
  12.5% {
    background-image: url("~@/assets/img/stage-manager-2.png");
  }
  12.5%,
  18.75% {
    background-image: url("~@/assets/img/stage-manager-3.png");
  }
  18.75%,
  25% {
    background-image: url("~@/assets/img/stage-manager-4.png");
  }
  25%,
  31.25% {
    background-image: url("~@/assets/img/stage-manager-5.png");
  }
  31.25%,
  37.5% {
    background-image: url("~@/assets/img/stage-manager-6.png");
  }
  37.5%,
  43.75% {
    background-image: url("~@/assets/img/stage-manager-7.png");
  }
  43.75%,
  50% {
    background-image: url("~@/assets/img/stage-manager-8.png");
  }
  50%,
  56.25% {
    background-image: url("~@/assets/img/stage-manager-10.png");
  }
  56.25%,
  62.5% {
    background-image: url("~@/assets/img/stage-manager-11.png");
  }
  68.75%,
  75% {
    background-image: url("~@/assets/img/stage-manager-12.png");
  }
  75%,
  81.25% {
    background-image: url("~@/assets/img/stage-manager-13.png");
  }
  81.25%,
  87.5% {
    background-image: url("~@/assets/img/stage-manager-14.png");
  }
  87.5%,
  93.75% {
    background-image: url("~@/assets/img/stage-manager-15.png");
  }
  93.75%,
  100% {
    background-image: url("~@/assets/img/stage-manager-16.png");
  }
}

.active-play {
  .stage-manager {
    animation: walk 4.5s step-start;
    background-size: contain;
    background-image: url("~@/assets/img/stage-manager-17.png");
  }
}

.stage-manager {
  position: absolute;
  background-repeat: no-repeat;
  bottom: fluid(7px);
  left: fluid(160px);
  width: fluid(150px);
  height: fluid(315px);

  img {
    display: none;
  }
}
</style>
